<template>
  <main class="auth-page">
    <section class="auth-card" aria-labelledby="forgot-title">
      <header class="auth-header">
        <img src="@/assets/images/lengedu.jpg" alt="Lengedu" class="auth-logo">
        <span class="auth-eyebrow">PAROLA YARDIMI</span>
        <h1 id="forgot-title">Parolanızı mı unuttunuz?</h1>
        <p>Parolanızı sıfırlama talimatlarını e-posta adresinize gönderelim.</p>
      </header>
      <form class="auth-form" @submit.prevent="submit" :aria-busy="form.isLoading">
        <div class="auth-field">
          <label for="email">E-posta adresi</label>
          <input id="email" v-model="form.username" type="email" placeholder="ornek@eposta.com" autocomplete="email" inputmode="email" :disabled="form.isLoading" required>
        </div>
        <button class="auth-submit" type="submit" :disabled="form.isLoading">
          <span v-if="form.isLoading" class="auth-spinner" aria-hidden="true"></span>
          <span aria-live="polite">{{ form.isLoading ? 'Gönderiliyor…' : 'Sıfırlama talimatlarını gönder' }}</span>
        </button>
      </form>
      <p class="auth-register"><router-link to="/login"><span aria-hidden="true">← </span>Giriş sayfasına dön</router-link></p>
    </section>
    <footer class="auth-footer"><VersionNumber /></footer>
  </main>
</template>

<script>
  import { mapActions } from "vuex";
  import VersionNumber from "@/components/Shared/VersionNumber.vue";
  import { LoadingToast,ErrorToast,UpdateToast,ToastType } from "@/common/notification.js";
  import {IsEmailValid} from "@/common/validation-email";
  export default {
    name: "ForgotPasswordPage",
    components: {
      VersionNumber
    },
    data() {
      return {
        form: {
          username: "",
          isLoading:false
        },
      };
    },
    methods: {
      ...mapActions(["ForgotPassword"]),
      async submit() {
        if (this.form.isLoading) return;
        if(!IsEmailValid(this.form.username)){
            ErrorToast('E-posta adresi geçersiz.');
            return;
        }

        let toastId = LoadingToast();
        this.form.isLoading=true;
        const request = {
          "UserName": this.form.username,
          "PanelType": 2
        };
        await this.ForgotPassword(request)
        .then((res)=>{
          this.form.isLoading=false;
          UpdateToast(toastId,res.description,ToastType().SUCCESS);
        })
        .catch(err=>{
          UpdateToast(toastId,err.message,ToastType().ERROR);
          this.form.isLoading=false;
        });
      },
    },
  };
  </script>

<style scoped src="@/assets/styles/auth.css"></style>
